import { useEffect, useState } from "react";
import { startOfToday, isBefore } from "date-fns";

// Manages expanded/collapsed state for date-grouped flight lists in the flights panel
export const useExpandedDatesState = (isEnabled, flightsByDate, selectedFlightId) => {
    const [expandedDates, setExpandedDates] = useState({});

    useEffect(() => {
        if (!isEnabled) return;
        const todayStart = startOfToday();
        setExpandedDates((previousState) => {
            const groupKeys = Object.keys(flightsByDate || {});
            const nextState = {};
            groupKeys.forEach((dateKey) => {
                if (Object.prototype.hasOwnProperty.call(previousState, dateKey)) {
                    nextState[dateKey] = previousState[dateKey];
                    return;
                }
                const firstFlight = flightsByDate[dateKey]?.[0];
                const departure = firstFlight?.departureDateTime ? new Date(firstFlight.departureDateTime) : null;
                const isInPast = departure ? isBefore(departure, todayStart) : false;
                nextState[dateKey] = !isInPast;
            });
            return nextState;
        });
    }, [isEnabled, flightsByDate]);

    useEffect(() => {
        if (!isEnabled || !selectedFlightId) return;
        const dateKeyWithSelected = Object.keys(flightsByDate || {}).find((dateKey) =>
            (flightsByDate[dateKey] || []).some((flight) => flight?.id === selectedFlightId)
        );
        if (!dateKeyWithSelected) return;
        setExpandedDates((previous) => ({ ...previous, [dateKeyWithSelected]: true }));
    }, [isEnabled, selectedFlightId, flightsByDate]);

    const handleAccordionChange = (dateKey) => (_event, isExpanded) => {
        setExpandedDates((previous) => ({ ...previous, [dateKey]: isExpanded }));
    };

    const expandAll = () => {
        const groupKeys = Object.keys(flightsByDate || {});
        const nextState = Object.fromEntries(groupKeys.map((key) => [key, true]));
        setExpandedDates(nextState);
    };

    const collapseAll = () => {
        const groupKeys = Object.keys(flightsByDate || {});
        const nextState = Object.fromEntries(groupKeys.map((key) => [key, false]));
        setExpandedDates(nextState);
    };

    return { expandedDates, handleAccordionChange, expandAll, collapseAll };
};

export default useExpandedDatesState;


